var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFillCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16035 4.51445L19.5729 13.4941C19.8709 13.7512 19.8709 14.2461 19.5729 14.5059L9.16035 23.4855C8.77207 23.8191 8.20332 23.5184 8.20332 22.9797V5.02031C8.20332 4.48164 8.77207 4.18085 9.16035 4.51445Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFillCaretRight);
export default __webpack_public_path__ + "static/media/AiFillCaretRight.2fa4504f35dcb544d5795cb0bef3fb76.svg";
export { ForwardRef as ReactComponent };